import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Minus = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="minus icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 10.8954 2.89543 10 4 10L20 10C21.1046 10 22 10.8954 22 12C22 13.1046 21.1046 14 20 14L4 14C2.89543 14 2 13.1046 2 12Z"
    />
  </svg>
)
